<span class="badge rounded-pill badge-text" data-test-selector="badge" [ngClass]="[bgClass]"
    [ngbTooltip]="tooltipMessage">
    <span>{{ text }}</span>
</span>
